import { useCallback } from 'react';
import { collectCredentialErrors, pickChangedFieldErrors } from '../credentialV2Utils';

const validate = (cred, noExpiration) => {
  const errors = {};

  if (!cred?.issued_at) {
    errors.issued_at = 'Issued date is required';
  }
  if (!cred?.expired_at && !noExpiration) {
    errors.expired_at = 'Expiration date is required';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) =>
  (current?.[field] ?? '') !== (original?.[field] ?? '');

export const useCredentialArtifact = () => {
  const getErrors = useCallback(
    (current, original, noExpiration) =>
      pickChangedFieldErrors(validate(current, noExpiration), current, original, hasFieldChanged),
    [],
  );

  const validateAll = useCallback(
    (credentials, noExpirations, getKey) =>
      collectCredentialErrors(
        credentials,
        (cred) => {
          const key = getKey(cred);
          const noExpiration = key in noExpirations ? noExpirations[key] : !cred?.expired_at;
          return validate(cred, noExpiration);
        },
        getKey,
      ),
    [],
  );

  return { getErrors, validateAll };
};
